// extracted by mini-css-extract-plugin
export default {"investment":"Investment_investment__i1gBe","container":"Investment_container__SFX02","leftSide":"Investment_leftSide__z3Ezw","rightSide":"Investment_rightSide__+p1eg"};